import { BankAccountsContext } from '@app/collections/fortress/BankAccountsContext'
import { Button, Col, Collapse, CollapsePanel, Divider, Notification, Row, Text } from '@app/components'
import { DynamicForm, generateDynamicFields } from '@app/modules'
import { IStore } from '@app/redux'
import { auth, errorHandler } from '@app/services'
import axios from 'axios'
import { ADD_NEW_ACH_FORM } from 'libs/data/forms/AddNewACH.form'
import React, { useContext, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { BankIcon } from '~public'

import { CustomSelect } from './custom-select'

export const ACHPullContent: React.FC<any> = ({ form, selectedMethod, setSelectedMethod }) => {
  const { bankAccounts, fetchAccounts } = useContext(BankAccountsContext)
  const [activeKey, setActiveKey] = useState(null)

  useEffect(() => {
    fetchAccounts()
  }, [])

  const handleCollapseChange = (key) => {
    setActiveKey(key)
  }

  const { user } = useSelector((state: IStore) => state)

  const onACHSubmit = async (key) => {
    try {
      const data = await form.validateFields()
      data.identityId = user.selectedEntityName ? user.selectedEntityIdentityId : null

      const authorization = await auth.currentUser.getIdToken()
      const headers = {
        Authorization: authorization,
      }
      await axios.post('/api/north-one/manual-ach', data, { headers })
    } catch (error) {
      Notification({ message: error.message, type: 'error' })
      errorHandler.report`Failed to add bank account manually: ${error}`
    } finally {
      handleCollapseChange(key)
      await fetchAccounts()
      //setSelectedMethod()
    }
  }

  /**
   * It takes the `accounts` array, maps over it, and returns an array of objects with the following
   * properties: `id`, `title`, `icon`, and `description`
   * @returns An array of objects.
   */
  const generateMethodList = () => {
    return (
      bankAccounts?.map((item) => {
        return {
          id: item.id,
          name: (
            <>
              <BankIcon /> <Text>{`${item['accountNumber']}`}</Text>
            </>
          ),
          //icon: <BankIcon />,
          description: item.plaid ? 'Plaid Linked External Account' : 'External Account',
          val: item?.id,
        }
      }) || []
    )
  }

  return (
    <>
      <Row gutter={[10, 10]}>
        <Col span={24}>
          <Row justify={'space-between'}>
            <Col>
              <Text>Bank Account</Text>
            </Col>
          </Row>
          <Divider style={{ marginTop: 0 }} />
          <CustomSelect
            type="External Account"
            selected={selectedMethod}
            setSelected={setSelectedMethod}
            list={generateMethodList()}
          />

          <Divider />

          <Collapse activeKey={activeKey} onChange={handleCollapseChange}>
            <CollapsePanel header="Add Bank Account Manually" key="3">
              <Row gutter={[10, 10]}>
                <Col span={24}>
                  <DynamicForm
                    fields={generateDynamicFields(ADD_NEW_ACH_FORM, [])}
                    form={form}
                    onSubmit={onACHSubmit}
                  />
                  <Button block onClick={onACHSubmit}>
                    Add Bank Account Manually
                  </Button>
                </Col>
              </Row>
            </CollapsePanel>
          </Collapse>
        </Col>
      </Row>
    </>
  )
}
